import { PHARMACY_NPIS } from '../pharmacies';
import type { MedicationProduct } from '../shared';

export const mounjaroProducts: MedicationProduct[] = [
    {
        description: 'Mounjaro® Autoinjector 2.5mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 2.5,
        imageUrl: '/static/img/mounjaro-2.5mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002150680', packageQuantity: 1 },
            { ndc: '00002150601', packageQuantity: 1 },
            { ndc: '00002150661', packageQuantity: 1 },
        ],
        pricing: { selfPay: 499 },
        headlinePrices: [
            {
                type: 'DiscountedCashPrice',
                value: 499,
                pharmacyNpis: [PHARMACY_NPIS.GIFTHEALTH],
            },
        ],
        pathway: {
            initialPathway: 'self-pay',
            initialScreen: 'path-select',
        },
    },
    {
        description: 'Mounjaro® Autoinjector 5mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 5,
        imageUrl: '/static/img/mounjaro-5mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002149580', packageQuantity: 1 },
            { ndc: '00002149501', packageQuantity: 1 },
        ],
        pricing: { selfPay: 499 },
        headlinePrices: [
            {
                type: 'DiscountedCashPrice',
                value: 499,
                pharmacyNpis: [PHARMACY_NPIS.GIFTHEALTH],
            },
        ],
        pathway: {
            initialPathway: 'self-pay',
            initialScreen: 'path-select',
        },
    },
    {
        description: 'Mounjaro® Autoinjector 7.5mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 7.5,
        imageUrl: '/static/img/mounjaro-7.5mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002148480', packageQuantity: 1 },
            { ndc: '00002148401', packageQuantity: 1 },
        ],
        pricing: { selfPay: 499 },
        headlinePrices: [
            {
                type: 'DiscountedCashPrice',
                value: 499,
                pharmacyNpis: [PHARMACY_NPIS.GIFTHEALTH],
            },
        ],
        pathway: {
            initialPathway: 'self-pay',
            initialScreen: 'path-select',
        },
    },
    {
        description: 'Mounjaro® Autoinjector 10mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 10,
        imageUrl: '/static/img/mounjaro-10mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002147180', packageQuantity: 1 },
            { ndc: '00002147101', packageQuantity: 1 },
        ],
        pricing: { selfPay: 499 },
        headlinePrices: [
            {
                type: 'DiscountedCashPrice',
                value: 499,
                pharmacyNpis: [PHARMACY_NPIS.GIFTHEALTH],
            },
        ],
        pathway: {
            initialPathway: 'self-pay',
            initialScreen: 'path-select',
        },
    },
    {
        description: 'Mounjaro® Autoinjector 12.5mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 12.5,
        imageUrl: '/static/img/mounjaro-12.5mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002146080', packageQuantity: 1 },
            { ndc: '00002146001', packageQuantity: 1 },
        ],
        pricing: { selfPay: 499 },
        headlinePrices: [
            {
                type: 'DiscountedCashPrice',
                value: 499,
                pharmacyNpis: [PHARMACY_NPIS.GIFTHEALTH],
            },
        ],
        pathway: {
            initialPathway: 'self-pay',
            initialScreen: 'path-select',
        },
    },
    {
        description: 'Mounjaro® Autoinjector 15mg/0.5mL',
        dosageForm: 'SOAJ',
        formLabel: 'Autoinjector',
        packageSizeUnit: 'EA',
        strengthUnit: 'mg',
        strengthValue: 15,
        imageUrl: '/static/img/mounjaro-15mg.png',
        imageOrientation: 'landscape',
        ndcs: [
            { ndc: '00002145780', packageQuantity: 1 },
            { ndc: '00002145701', packageQuantity: 1 },
        ],
        pricing: { selfPay: 499 },
        headlinePrices: [
            {
                type: 'DiscountedCashPrice',
                value: 499,
                pharmacyNpis: [PHARMACY_NPIS.GIFTHEALTH],
            },
        ],
        pathway: {
            initialPathway: 'self-pay',
            initialScreen: 'path-select',
        },
    },
];
